<div class="progress-bar z-50 sticky bottom-[5vh] w-[50vw] mx-auto" *ngIf="progressBarActive">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
